import { render, staticRenderFns } from "./SiteEmpty.vue?vue&type=template&id=2714a47b"
import script from "./SiteEmpty.vue?vue&type=script&lang=js"
export * from "./SiteEmpty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports